define("shared/components/shared/linkinbio/slug-validator/task", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "ember-concurrency-ts", "later/utils/constants", "later/utils/fetch"], function (_exports, _component, _templateFactory, _service, _utils, _component2, _tracking, _emberConcurrency, _emberConcurrencyTs, _constants, _fetch) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _markInvalid;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"ember-concurrency-ts",0,"later/utils/constants",0,"later/utils/fetch"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{yield (hash errorMessage=this.errorMessage isValid=this.isValid slug=this.slug validate=this.validate)}}
  */
  {
    "id": "psPrKS73",
    "block": "[[[18,1,[[28,[37,1],null,[[\"errorMessage\",\"isValid\",\"slug\",\"validate\"],[[30,0,[\"errorMessage\"]],[30,0,[\"isValid\"]],[30,0,[\"slug\"]],[30,0,[\"validate\"]]]]]]]],[\"&default\"],false,[\"yield\",\"hash\"]]",
    "moduleName": "shared/components/shared/linkinbio/slug-validator/task.hbs",
    "isStrictMode": false
  });

  const DEBOUNCE_TIME = 500;
  const MINIMUM_CHARACTERS = 2;
  const ONE_MILLISECOND = 1;
  let SlugValidatorTaskComponent = (_class = (_markInvalid = /*#__PURE__*/new WeakSet(), class SlugValidatorTaskComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _classPrivateMethodInitSpec(this, _markInvalid);

      _initializerDefineProperty(this, "intl", _descriptor, this);

      _initializerDefineProperty(this, "errorMessage", _descriptor2, this);

      _initializerDefineProperty(this, "slug", _descriptor3, this);

      _defineProperty(this, "initialSlug", void 0);

      this.initialSlug = this.args.slug;
      this.slug = this.args.slug || '';

      if (this.args.validateInitialSlug) {
        (0, _emberConcurrencyTs.taskFor)(this.validate).perform();
      }
    }

    get isValid() {
      return !(0, _emberConcurrencyTs.taskFor)(this.validate).isRunning && !this.errorMessage && !this.args.isDisabled;
    }

    *validate() {
      const waitForNextRunloop = async () => await (0, _emberConcurrency.rawTimeout)(ONE_MILLISECOND);

      let message = undefined;
      yield waitForNextRunloop();

      _classPrivateMethodGet(this, _markInvalid, _markInvalid2).call(this, message);

      if (!this.args.validateInitialSlug && this.initialSlug === this.slug && Boolean(this.slug)) {
        return;
      }

      yield (0, _emberConcurrency.timeout)(DEBOUNCE_TIME);

      if (!(0, _utils.isPresent)(this.slug)) {
        message = this.intl.t('linkinbio.choose_your_handle.error.empty');
      } else if (this.slug.length < MINIMUM_CHARACTERS) {
        message = this.intl.t('linkinbio.choose_your_handle.error.short');
      } else if (!new RegExp(_constants.LINKINBIO_HANDLE_VALIDATION_REGEX).test(this.slug)) {
        message = this.intl.t('linkinbio.choose_your_handle.error.characters');
      } else {
        try {
          yield (0, _fetch.fetch)(`api/v2/linkinbio_pages/slug_verify?slug=${this.slug.toLowerCase()}`);
          this.args.onValid?.(this.slug.toLowerCase());
        } catch (error) {
          message = this.intl.t('linkinbio.choose_your_handle.error.unavailable');

          _classPrivateMethodGet(this, _markInvalid, _markInvalid2).call(this, message);

          return;
        }
      }

      if (message) {
        _classPrivateMethodGet(this, _markInvalid, _markInvalid2).call(this, message);
      }
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errorMessage", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "slug", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "validate", [_emberConcurrency.restartableTask], Object.getOwnPropertyDescriptor(_class.prototype, "validate"), _class.prototype)), _class);
  _exports.default = SlugValidatorTaskComponent;

  function _markInvalid2(message) {
    this.args.onInvalid?.(message);
    this.errorMessage = message;
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SlugValidatorTaskComponent);
});